import HexCard from "..";
import HexTitle from "../../HexTitle";

const TitleCard = ({ title, className, borderless }) => {
  return (
    <HexCard
      className={`content-card ${!borderless ? "card-bottom-divider" : ""} ${
        className || ""
      }`}
    >
      <HexTitle title={title} className={"font-18-regular-500-lh-22"} />
    </HexCard>
  );
};

export default TitleCard